export const environment = {
  production: true,
  API_URL: 'https://api.chegaderonco.com.br/api/v1'
  // API_URL: 'https://api-chegaderonco.is-on.cloud/api/v1'
};
